import { useLayoutEffect } from "react";

import Popup from "reactjs-popup";
import scss from "./ShareImagePopup.module.scss";

export const ShareImagePopup = ({ shareImage, setShareImage }) => {
  useLayoutEffect(() => {
    // Get original body overflow
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // Prevent scrolling on mount
    document.body.style.overflow = "hidden";
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const handleClose = () => {
    setShareImage("");
  };

  return (
    <Popup open={true}>
      <div onClick={handleClose} className={scss.overlay}>
        <img alt="share" className={scss.shareImage} src={shareImage} />
        <div className={scss.instructions}>
          Tap and hold the photo to save it to your device, then share on social
          media
        </div>
      </div>
    </Popup>
  );
};
